module.exports = __webpack_public_path__ + "img/logo-haft.ff74b09e.png";